import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-apm-sigh",
  "use": "icon-apm-sigh-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-apm-sigh\">\r\n    <g id=\"icon-apm-sigh_页面-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"icon-apm-sigh_确认复审\" transform=\"translate(-781.000000, -423.000000)\" fill=\"#ED7B2F\">\r\n            <g id=\"icon-apm-sigh_error-circle-filled\" transform=\"translate(781.000000, 423.000000)\">\r\n                <path d=\"M10.5,0 C4.70101368,0 0,4.70100725 0,10.5 C0,16.2989874 4.70100725,21 10.5,21 C16.2989874,21 21,16.2989931 21,10.5 C21,4.70101368 16.2989931,0 10.5,0 Z M11.2499971,12.7499914 L9.74999714,12.7499914 L9.74999714,4.50045455 L11.2499971,4.50045455 L11.2499971,12.7499914 Z M11.3914275,15 L11.3914275,16.7999911 L9.5914278,16.7999911 L9.5914278,15 L11.3914275,15 Z\" />\r\n            </g>\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/apm-sigh.svg
// module id = M4hP
// module chunks = 57